module.exports = __webpack_public_path__ + "static/img/qq.528cd1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/xiaotubiao/qq.png
// module id = Jckw
// module chunks = 41